import Container from "react-bootstrap/Container";
import "./listandexpand.scss";
import { Col, Nav, OverlayTrigger, Row, Tab, Tooltip } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import WebService from "../../../Services/WebService";
import { useEffect, useState } from "react";
import BackButton from "../../Common/BackButton/BackButton";
import CardSkeleton from "../CardSkeleton";
import ProductCarouselModal from "../../Businesses/ProductCarouselModal";
import {
  ACCOUNT_TYPE_API,
  SUBSCRIPTION_BUY_MODE,
} from "../../../assets/constants/constants";
import ConfirmSubscriptionModal from "../../Login/Subscription/BuySubscriptionApprovalModal";
import PrimeSharkNoRecord from "../../Home/NoDataFound/AIDataNotFound";
import VerifiedBadge from "../../Common/VerificationTag";
import ProfileJourneySection from "../../ProfileJourney/ProfileJourneySection";
import { FiPackage } from "react-icons/fi";

const Listandexpand = () => {
  const [globalConnectList, setGlobalConnectList] = useState<any[]>([]);
  const [industriesList, setIndustriesList] = useState<any[]>([]);
  const [gcLoading, setGcLoading] = useState(true);
  const [indLoading, setIndLoading] = useState(false);
  const [indFetched, setIndFetched] = useState(false);
  const [productIdx, setProductIdx] = useState(0);
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselStart, setCarouselStart] = useState(0);
  const [selectedProductList, setSelectedProductList] = useState<any[]>([]);
  const activeLoginTypes = useSelector(
    (state: any) => state?.items?.storeActiveLoginType,
  );

  let navigate = useNavigate();
  let account_type = activeLoginTypes?.account_type;
  let login_type = activeLoginTypes?.loginType;
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [subscriptionMode, setSubscriptionMode] = useState("");
  const [aiRecordData, setAIRecordData] = useState<any>({
    message: "",
    profile_incomplete: false,
  });

  const [showProfileJourney, setShowProfileJourney] = useState(false);

  let sectionKey = "list_and_expand";
  let profile_journey_info = useSelector(
    (state: any) => state?.items?.profile_journey_info || null,
  );
  const sections = profile_journey_info?.sections || [];
  const section = sections.find((item: any) => item.key === sectionKey);

  useEffect(() => {
    if (
      account_type?.toLowerCase() === ACCOUNT_TYPE_API["WANT_TO_GROW"] ||
      account_type?.toLowerCase() === ACCOUNT_TYPE_API.INVESTMENT
    ) {
      const today = new Date().toISOString().split("T")[0];
      if (
        localStorage.getItem("list_and_expand_journey_shown_date") !== today &&
        section?.fields?.length
      ) {
        setShowProfileJourney(true);
      } else {
        fetchGlobalConnect();
      }
    } else {
      fetchGlobalConnect();
    }
  }, [section]);

  const fetchGlobalConnect = () => {
    let action = "";
    action = "list-expand/global/global-connect";

    if (!action) return;
    setGcLoading(true);
    WebService.getAPI({
      action: `${action}`,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status === "success" && res?.results?.length > 0) {
          setGlobalConnectList(res.results);
        } else {
          setAIRecordData({
            profile_incomplete: res?.profile_incomplete,
            message: res?.message,
          });
          setGlobalConnectList([]);
        }
      })
      .catch(() => setGlobalConnectList([]))
      .finally(() => setGcLoading(false));
  };

  // ── Tab 2: Industries & Opportunities — fetch on tab switch (once) ──────
  const fetchIndustriesOpportunities = () => {
    if (indFetched) return;
    let action = "";
    // if (account_type === "want-to-grow") {
    action = "list-expand/global/industries_opportunities";
    // } else if (
    //   account_type === "investment" ||
    //   account_type === "want-to-sell"
    // ) {
    //   action = "list-expand/capital_bridge/industries_opportunities";
    // }
    if (!action) return;

    setIndLoading(true);
    WebService.getAPI({
      action: `${action}`,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status === "success" && res?.results?.length > 0) {
          setIndustriesList(res.results);
        } else {
          setAIRecordData({
            profile_incomplete: res?.profile_incomplete,
            message: res?.message,
          });
          setIndustriesList([]);
        }
      })
      .catch(() => setIndustriesList([]))
      .finally(() => {
        setIndLoading(false);
        setIndFetched(true);
      });
  };
  useEffect(() => {
    fetchGlobalConnect();
  }, []);
  const handleConnect = (uuid: string) => {
    WebService.addLoader(`btn_connect_${uuid}`);
    return WebService.postAPI({
      action: `start-business-chat`,
      body: { business_id: uuid },
      isShowError: true,
    })
      .then((res: any) => {
        if (res?.status)
          navigate(`/entrepreneur/${account_type}/chats/${res?.chat_id}`);
      })
      .catch((error: any) => {
        return false;
      })
      .finally(() => {
        WebService.removeLoader(`btn_connect_${uuid}`);
      });
  };
  const handleShowModal = () => {
    setSubscriptionMode(SUBSCRIPTION_BUY_MODE.UPGRADE);
    setModalMessage(
      ` Access to this profile is restricted based on your selected region.
   Modify your region preferences or upgrade your plan to proceed.`,
    );
    setShowModal(true);
  };
  const handleYes = () => {
    navigate(
      `/${login_type?.toLowerCase()}/${account_type?.toLowerCase()}/subscriptions?mode=${subscriptionMode}`,
    );
  };
  return (
    <>
      <section className="investor-page">
        <Container>
          <div className="d-flex align-items-center justify-content-between mb-2 mt-3">
            <div className="d-flex align-items-center gap-2">
              <BackButton />
              <h4 className="mb-0 fw-bold">List & Expand</h4>{" "}
            </div>
          </div>
          <h5 className="font-bold">
            AI-enabled discovery for global partnerships.
          </h5>

          <p className="col-lg-12">
            Discover verified global partners tailored to your business needs.
            Prime Shark connects you with the right opportunities to list your
            business and expand your reach across international markets.
          </p>

          <Tab.Container
            id="left-tabs-example"
            defaultActiveKey="first"
            onSelect={(key) => {
              if (key === "second") {
                setAIRecordData({
                  profile_incomplete: false,
                  message: "",
                });
                fetchIndustriesOpportunities();
              }
            }}
          >
            <Row>
              <Col sm={12}>
                <Nav variant="underline" className="d-flex gap-4">
                  <Nav.Item>
                    <Nav.Link eventKey="first">Global Connect Users</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="second">
                      Industries & Opportunities
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col sm={12} className="mt-0">
                <Tab.Content>
                  <Tab.Pane eventKey="first" className="py-4">
                    <Row className="g-4">
                      {gcLoading ? (
                        <Row className="g-4 w-100">
                          {[...Array(6)].map((_, index) => (
                            <Col xs={12} md={6} lg={4} key={index} className="mb-3">
                              <CardSkeleton />
                            </Col>
                          ))}
                        </Row>
                      ) : globalConnectList.length === 0 ? (
                        <Row className="w-100 vh-75 d-flex justify-content-center align-items-center m-3">
                          <Col lg={12} className="text-center">
                            {/* <NoDataFound message="No matching records found!" /> */}
                            <PrimeSharkNoRecord
                              text={aiRecordData?.message}
                              showButton={aiRecordData?.profile_incomplete}
                              titleMsg="No Business Matches"
                            />
                          </Col>
                        </Row>
                      ) : (
                        globalConnectList.map((item: any, index: number) => {
                          const initials = item?.name
                            ?.split(" ")
                            ?.map((n: string) => n[0])
                            ?.join("")
                            ?.toUpperCase();
                          const nameText = item?.name || "-";
                          const isLongName = nameText.length > 20;
                          const location = item?.country || "-";
                          const isLongLocation = location.length > 20;
                          const primary_objectives =
                            item?.primary_objective || "-";
                          const ispbLong = primary_objectives.length > 20;
                          return (
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="d-flex align-items-stretch mb-4"
                              key={index}
                            >
                              <div className="business-card p-3 w-100 d-flex flex-column justify-content-between">
                              {/* Header */}
                              <div className="d-flex justify-content-between align-items-start border-bottom">
                                {/* Left */}
                                <div className="d-flex gap-3">
                                  {item?.profile_image ? (
                                    <img
                                      src={item?.profile_image}
                                      alt={"profile"}
                                      width={45}
                                      height={45}
                                      className="rounded-circle object-fit-cover flex-shrink-0"
                                      style={{ objectFit: "cover" }}
                                      onError={(e) => {
                                        (
                                          e.target as HTMLImageElement
                                        ).style.display = "none";
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="d-flex align-items-center justify-content-center text-white fw-bold flex-shrink-0"
                                      style={{
                                        width: 45,
                                        height: 45,
                                        borderRadius: "50%",
                                        background: "#2e4a3f",
                                      }}
                                    >
                                      {initials}
                                    </div>
                                  )}

                                  {/* Name + meta */}
                                  <div>
                                    <div className="overflow-hidden">
                                      {isLongName ? (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip
                                              id={`name-tooltip-${index}`}
                                            >
                                              {nameText}
                                            </Tooltip>
                                          }
                                        >
                                          <h5 className="fw-bold mb-1 text-truncate">
                                            {nameText.slice(0, 15)}...
                                          </h5>
                                        </OverlayTrigger>
                                      ) : (
                                        <h5 className="fw-bold mb-1 text-truncate">
                                          {nameText}
                                        </h5>
                                      )}

                                      <div className="location">
                                        <img
                                          src={item?.flag}
                                          className="me-2 mb-2 flag"
                                        />
                                        {isLongLocation ? (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={
                                              <Tooltip
                                                id={`location-tooltip-${index}`}
                                              >
                                                {location}
                                              </Tooltip>
                                            }
                                          >
                                            <span className="">
                                              {location.slice(0, 20)}...
                                            </span>
                                          </OverlayTrigger>
                                        ) : (
                                          <span className="">{location}</span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                  <VerifiedBadge
                                    isVerified={item?.is_verified === "VERIFIED"}
                                  />
                                </div>
                              </div>

                              <div className="row gy-0 mt-4">
                                {/* Primary Objective */}
                                <div className="d-flex gap-2 mb-0">
                                  <span className="global-card-title col-lg-6">
                                    Primary Objective{" "}
                                  </span>

                                  {ispbLong ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id={`name-tooltip-${index}`}>
                                          {primary_objectives}
                                        </Tooltip>
                                      }
                                    >
                                      <h5 className="global-card-info mb-1 text-truncate">
                                        {primary_objectives.slice(0, 20)}...
                                      </h5>
                                    </OverlayTrigger>
                                  ) : (
                                    <span className="label">
                                      {" "}
                                      {primary_objectives}
                                    </span>
                                  )}
                                </div>

                                <div className="d-flex gap-2 mb-0">
                                  <span className="global-card-title col-lg-6">
                                    Operational Region{" "}
                                  </span>
                                  <div className="global-card-info">
                                    {item?.operational_region?.length > 30 ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id={`name-tooltip-${index}`}>
                                            {item?.operational_region}
                                          </Tooltip>
                                        }
                                      >
                                        <h5 className="global-card-info mb-1 text-truncate">
                                          {item?.operational_region?.slice(
                                            0,
                                            30,
                                          )}
                                          ...
                                        </h5>
                                      </OverlayTrigger>
                                    ) : (
                                      <span className="label">
                                        {" "}
                                        {item?.operational_region}
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="d-flex gap-2 mb-0">
                                  <span className="global-card-title col-lg-6">
                                    Industry{" "}
                                  </span>
                                  <span className="fw-semibold">
                                    {item?.industry &&
                                    item?.industry.length > 30 ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip
                                            id={`industry-tooltip-${index}`}
                                          >
                                            {item?.industry}
                                          </Tooltip>
                                        }
                                      >
                                        <span
                                          className="badge rounded-pill px-2 py-1"
                                          style={{
                                            backgroundColor: "#E4FFE5",
                                            color: "#2f4f46",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {item?.industry.slice(0, 30)}...
                                        </span>
                                      </OverlayTrigger>
                                    ) : (
                                      <span
                                        className="badge rounded-pill px-2 py-1"
                                        style={{
                                          backgroundColor: "#E4FFE5",
                                          color: "#2f4f46",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {item?.industry}
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </div>

                              {/* Info Grid */}
                              <div className="row mb-0 mt-3">
                                <div className="col-md-4 mb-2 text-start">
                                  <div className="global-card-title">Type</div>
                                  <div className="global-card-info">
                                    {item?.business_model?.length > 30 ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id={`name-tooltip-${index}`}>
                                            {item?.business_model}
                                          </Tooltip>
                                        }
                                      >
                                        <h5 className="global-card-info mb-1 text-truncate">
                                          {item?.business_model?.slice(0, 15)}
                                          ...
                                        </h5>
                                      </OverlayTrigger>
                                    ) : (
                                      <span className="label">
                                        {" "}
                                        {item?.business_model}
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-4 mb-2 text-center">
                                  <div className="global-card-title">
                                    Year Established
                                  </div>
                                  <div className="global-card-info">
                                    {item?.year_established}
                                  </div>
                                </div>

                                <div className="col-md-4 mb-2 text-end">
                                  <div className="global-card-title">
                                    Employees
                                  </div>
                                  <div className="global-card-info">
                                    {item?.employees}
                                  </div>
                                </div>
                              </div>

                              <p
                                className="mt-1 mb-2 days card-about"
                                style={{
                                  color: "#204136",
                                  fontSize: "15px",
                                  fontWeight: "400",
                                  height: "64px",
                                  minHeight: "64px",
                                  maxHeight: "64px",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {item?.description}
                              </p>

                              {/* <div className="products-header"> */}
                              {/* <span className="more text-end">
                                More Details <span className="arrow">▶</span>
                              </span> */}
                              {/* </div> */}
                              <div className="products-container">
                                <Row>
                                  <Col>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                      <h6 className="font-bold">Products</h6>
                                      {item?.products.length > 0 && (
                                        <small className="text-muted">
                                          {selectedCardIndex === index
                                            ? productIdx + 1
                                            : 1}{" "}
                                          / {item?.products.length}
                                        </small>
                                      )}
                                    </div>

                                    {item?.products.length > 0 ? (
                                      <>
                                        <div className="d-flex align-items-center gap-1">
                                          <button
                                            className="btn btn-sm btn-outline-secondary rounded-circle p-0 flex-shrink-0"
                                            style={{
                                              width: 26,
                                              height: 26,
                                              lineHeight: 1,
                                            }}
                                            disabled={productIdx === 0}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setSelectedCardIndex(index);
                                              setProductIdx((i) => i - 1);
                                            }}
                                          >
                                            ‹
                                          </button>

                                          {/* Clickable product tile */}
                                          <div
                                            className="d-flex align-items-center gap-2 rounded p-2 flex-grow-1"
                                            style={{
                                              background: "var(--bs-gray-100)",
                                              cursor: "pointer",
                                              minWidth: 0,
                                            }}
                                            onClick={() => {
                                              setCarouselStart(productIdx);
                                              setSelectedProductList(
                                                item?.products?.length > 0
                                                  ? item?.products?.map(
                                                      (p: any) => ({
                                                        ...p,
                                                        image_url: p?.image,
                                                      }),
                                                    )
                                                  : [],
                                              );
                                              setShowCarousel(true);
                                            }}
                                          >
                                            {(() => {
                                              const p =
                                                selectedCardIndex === index
                                                  ? (item?.products[
                                                      productIdx
                                                    ] as any)
                                                  : (item?.products[0] as any);

                                              return (
                                                <>
                                                  {p?.image ? (
                                                    <img
                                                      src={p.image}
                                                      alt={p.title}
                                                      width={72}
                                                      height={56}
                                                      className="rounded object-fit-cover border flex-shrink-0"
                                                    />
                                                  ) : (
                                                    <div
                                                      style={{
                                                        width: 72,
                                                        height: 56,
                                                        background: "#f0f0f0",
                                                        borderRadius: 4,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        fontSize: 11,
                                                        color: "#777",
                                                        flexShrink: 0,
                                                      }}
                                                    >
                                                      No img
                                                    </div>
                                                  )}
                                                  <div style={{ minWidth: 0 }}>
                                                    <div
                                                      className="fw-semibold text-truncate"
                                                      style={{ fontSize: 13 }}
                                                    >
                                                      {p?.name}
                                                    </div>
                                                    <div
                                                      className="text-muted text-truncate"
                                                      style={{ fontSize: 11 }}
                                                    >
                                                      {p?.description}
                                                    </div>
                                                  </div>
                                                </>
                                              );
                                            })()}
                                          </div>

                                          <button
                                            className="btn btn-sm btn-outline-secondary rounded-circle p-0 flex-shrink-0"
                                            style={{
                                              width: 26,
                                              height: 26,
                                              lineHeight: 1,
                                            }}
                                            disabled={
                                              productIdx ===
                                              item?.products.length - 1
                                            }
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setSelectedCardIndex(index);
                                              setProductIdx((i) => i + 1);
                                            }}
                                          >
                                            ›
                                          </button>
                                        </div>

                                        {/* Dots */}
                                        <div className="d-flex justify-content-center gap-1 mt-1">
                                          {item?.products.map(
                                            (_: any, i: number) => (
                                              <div
                                                key={i}
                                                onClick={() => setProductIdx(i)}
                                                style={{
                                                  width: 5,
                                                  height: 5,
                                                  borderRadius: "50%",
                                                  cursor: "pointer",
                                                  background:
                                                    i === productIdx
                                                      ? "#66C15E"
                                                      : "#ccc",
                                                }}
                                              />
                                            ),
                                          )}
                                        </div>
                                        <small
                                          className="d-block text-center text-muted mt-1"
                                          style={{ fontSize: 10 }}
                                        >
                                          Click to view details
                                        </small>
                                      </>
                                    ) : (
                                      <span className="text-muted font-12">
                                        No Product Data Added
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                              </div>

                              {/* Buttons */}
                              <div className="d-flex gap-3">
                                <button
                                  className="btn flex-grow-1 text-white fw-semibold py-2"
                                  style={{
                                    background: "#7bb66a",
                                    borderRadius: 8,
                                    fontSize: 14,
                                  }}
                                  onClick={() =>
                                    handleConnect(item?.business_info_uuid)
                                  }
                                  id={`btn_connect_${item?.business_info_uuid}`}
                                >
                                  Connect
                                </button>

                                <button
                                  className="btn btn-outline-success bg-white text-success flex-grow-1  fw-semibold py-2"
                                  style={{
                                    background: "#7bb66a",
                                    borderRadius: 8,
                                    fontSize: 14,
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/${login_type}/${account_type}/smart-insight/${item?.user_uuid}`,
                                    )
                                  }
                                >
                                  View Profile
                                </button>
                              </div>
                            </div>
                          </Col>
                        );
                        })
                      )}
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second" className="p-4 px-0">
                    <Row className="g-4">
                      {indLoading ? (
                        <Row className="g-4 w-100">
                          {[...Array(6)].map((_, index) => (
                            <Col xs={12} md={6} lg={4} key={index} className="mb-3">
                              <CardSkeleton />
                            </Col>
                          ))}
                        </Row>
                      ) : industriesList?.length === 0 ? (
                        <PrimeSharkNoRecord
                          text={aiRecordData?.message}
                          showButton={aiRecordData?.profile_incomplete}
                          titleMsg="No Partnership Matches"
                        />
                      ) : (
                        industriesList?.map((item: any, index: number) => {
                          const initials = item?.name
                            ?.split(" ")
                            ?.map((n: string) => n[0])
                            ?.join("")
                            ?.toUpperCase();
                          const nameText = item?.name || "-";
                          const isLongName = nameText.length > 20;
                          const location = item?.country || "-";
                          const isLongLocation = location.length > 20;
                          const primary_objectives =
                            item?.primary_objective || "-";
                          const ispbLong = primary_objectives.length > 20;
                          return (
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="d-flex align-items-stretch mb-4"
                              key={index}
                            >
                              <div className="business-card p-3 w-100 d-flex flex-column justify-content-between">
                              {/* Header */}
                              <div className="d-flex justify-content-between align-items-start border-bottom">
                                {/* Left */}
                                <div className="d-flex gap-3">
                                  {item?.profile_image ? (
                                    <img
                                      src={item?.profile_image}
                                      alt={"profile"}
                                      width={45}
                                      height={45}
                                      className="rounded-circle object-fit-cover flex-shrink-0"
                                      style={{ objectFit: "cover" }}
                                      onError={(e) => {
                                        (
                                          e.target as HTMLImageElement
                                        ).style.display = "none";
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="d-flex align-items-center justify-content-center text-white fw-bold flex-shrink-0"
                                      style={{
                                        width: 45,
                                        height: 45,
                                        borderRadius: "50%",
                                        background: "#2e4a3f",
                                      }}
                                    >
                                      {initials}
                                    </div>
                                  )}

                                  {/* Name + meta */}
                                  <div>
                                    <div className="overflow-hidden">
                                      {isLongName ? (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip
                                              id={`name-tooltip-${index}`}
                                            >
                                              {nameText}
                                            </Tooltip>
                                          }
                                        >
                                          <h5 className="fw-bold mb-1 text-truncate">
                                            {nameText.slice(0, 15)}...
                                          </h5>
                                        </OverlayTrigger>
                                      ) : (
                                        <h5 className="fw-bold mb-1 text-truncate">
                                          {nameText}
                                        </h5>
                                      )}

                                      <div className="location">
                                        <img
                                          src={item?.flag}
                                          className="me-2 mb-2 flag"
                                        />
                                        {isLongLocation ? (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={
                                              <Tooltip
                                                id={`location-tooltip-${index}`}
                                              >
                                                {location}
                                              </Tooltip>
                                            }
                                          >
                                            <span className="">
                                              {location.slice(0, 20)}...
                                            </span>
                                          </OverlayTrigger>
                                        ) : (
                                          <span className="">{location}</span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                  <VerifiedBadge
                                    isVerified={item?.is_verified === "VERIFIED"}
                                  />
                                </div>
                              </div>

                              <div className="row gy-0 mt-4">
                                {/* Primary Objective */}
                                <div className="d-flex gap-2 mb-0">
                                  <span className="global-card-title col-lg-6">
                                    Primary Objective{" "}
                                  </span>

                                  {ispbLong ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id={`name-tooltip-${index}`}>
                                          {primary_objectives}
                                        </Tooltip>
                                      }
                                    >
                                      <h5 className="global-card-info mb-1 text-truncate">
                                        {primary_objectives.slice(0, 20)}...
                                      </h5>
                                    </OverlayTrigger>
                                  ) : (
                                    <span className="label">
                                      {" "}
                                      {primary_objectives}
                                    </span>
                                  )}
                                </div>

                                <div className="d-flex gap-2 mb-0">
                                  <span className="global-card-title col-lg-6">
                                    Operational Region{" "}
                                  </span>
                                  <div className="global-card-info">
                                    {item?.operational_region?.length > 30 ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id={`name-tooltip-${index}`}>
                                            {item?.operational_region}
                                          </Tooltip>
                                        }
                                      >
                                        <h5 className="global-card-info mb-1 text-truncate">
                                          {item?.operational_region?.slice(
                                            0,
                                            30,
                                          )}
                                          ...
                                        </h5>
                                      </OverlayTrigger>
                                    ) : (
                                      <span className="label">
                                        {" "}
                                        {item?.operational_region}
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="d-flex gap-2 mb-0">
                                  <span className="global-card-title col-lg-6">
                                    Industry{" "}
                                  </span>
                                  <span className="fw-semibold">
                                    {item?.industry &&
                                    item?.industry.length > 30 ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip
                                            id={`industry-tooltip-${index}`}
                                          >
                                            {item?.industry}
                                          </Tooltip>
                                        }
                                      >
                                        <span
                                          className="badge rounded-pill px-2 py-1"
                                          style={{
                                            backgroundColor: "#E4FFE5",
                                            color: "#2f4f46",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {item?.industry.slice(0, 30)}...
                                        </span>
                                      </OverlayTrigger>
                                    ) : (
                                      <span
                                        className="badge rounded-pill px-2 py-1"
                                        style={{
                                          backgroundColor: "#E4FFE5",
                                          color: "#2f4f46",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {item?.industry}
                                      </span>
                                    )}
                                  </span>
                                </div>
                              </div>

                              {/* Info Grid */}
                              <div className="row mb-0 mt-3">
                                <div className="col-md-4 mb-2 text-start">
                                  <div className="global-card-title">Type</div>
                                  <div className="global-card-info">
                                    {item?.business_model?.length > 30 ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id={`name-tooltip-${index}`}>
                                            {item?.business_model}
                                          </Tooltip>
                                        }
                                      >
                                        <h5 className="global-card-info mb-1 text-truncate">
                                          {item?.business_model?.slice(0, 15)}
                                          ...
                                        </h5>
                                      </OverlayTrigger>
                                    ) : (
                                      <span className="label">
                                        {" "}
                                        {item?.business_model}
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-4 mb-2 text-center">
                                  <div className="global-card-title">
                                    Year Established
                                  </div>
                                  <div className="global-card-info">
                                    {item?.year_established}
                                  </div>
                                </div>

                                <div className="col-md-4 mb-2 text-end">
                                  <div className="global-card-title">
                                    Employees
                                  </div>
                                  <div className="global-card-info">
                                    {item?.employees}
                                  </div>
                                </div>
                              </div>

                              <p
                                className="mt-1 mb-2 days card-about"
                                style={{
                                  color: "#204136",
                                  fontSize: "15px",
                                  fontWeight: "400",
                                  height: "64px",
                                  minHeight: "64px",
                                  maxHeight: "64px",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {item?.description}
                              </p>

                              <div className="products-container">
                                <Row>
                                  <Col>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                      <h6 className="font-bold">Products</h6>
                                      {item?.products.length > 0 && (
                                        <small className="text-muted">
                                          {productIdx + 1} /{" "}
                                          {item?.products.length}
                                        </small>
                                      )}
                                    </div>

                                    {item?.products.length > 0 ? (
                                      <>
                                        <div className="d-flex align-items-center gap-1">
                                          <button
                                            className="btn btn-sm btn-outline-secondary rounded-circle p-0 flex-shrink-0"
                                            style={{
                                              width: 26,
                                              height: 26,
                                              lineHeight: 1,
                                            }}
                                            disabled={productIdx === 0}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setProductIdx((i) => i - 1);
                                            }}
                                          >
                                            ‹
                                          </button>

                                          {/* Clickable product tile */}
                                          <div
                                            className="d-flex align-items-center gap-2 rounded p-2 flex-grow-1"
                                            style={{
                                              background: "var(--bs-gray-100)",
                                              cursor: "pointer",
                                              minWidth: 0,
                                            }}
                                            onClick={() => {
                                              setCarouselStart(productIdx);
                                              setSelectedProductList(
                                                item?.products?.length > 0
                                                  ? item?.products?.map(
                                                      (p: any) => ({
                                                        ...p,
                                                        image_url: p?.image,
                                                      }),
                                                    )
                                                  : [],
                                              );
                                              setShowCarousel(true);
                                            }}
                                          >
                                            {(() => {
                                              const p = item?.products[
                                                productIdx
                                              ] as any;
                                              return (
                                                <>
                                                  {p?.image ? (
                                                    <img
                                                      src={p.image}
                                                      alt={p.title}
                                                      width={72}
                                                      height={56}
                                                      className="rounded object-fit-cover border flex-shrink-0"
                                                    />
                                                  ) : (
                                                    <div
                                                      style={{
                                                        width: 72,
                                                        height: 56,
                                                        background: "#f0f0f0",
                                                        borderRadius: 4,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        fontSize: 11,
                                                        color: "#777",
                                                        flexShrink: 0,
                                                      }}
                                                    >
                                                      No img
                                                    </div>
                                                  )}
                                                  <div style={{ minWidth: 0 }}>
                                                    <div
                                                      className="fw-semibold text-truncate"
                                                      style={{ fontSize: 13 }}
                                                    >
                                                      {p?.name}
                                                    </div>
                                                    <div
                                                      className="text-muted text-truncate"
                                                      style={{ fontSize: 11 }}
                                                    >
                                                      {p?.description}
                                                    </div>
                                                  </div>
                                                </>
                                              );
                                            })()}
                                          </div>

                                          <button
                                            className="btn btn-sm btn-outline-secondary rounded-circle p-0 flex-shrink-0"
                                            style={{
                                              width: 26,
                                              height: 26,
                                              lineHeight: 1,
                                            }}
                                            disabled={
                                              productIdx ===
                                              item?.products.length - 1
                                            }
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setProductIdx((i) => i + 1);
                                            }}
                                          >
                                            ›
                                          </button>
                                        </div>

                                        {/* Dots */}
                                        <div className="d-flex justify-content-center gap-1 mt-1">
                                          {item?.products.map(
                                            (_: any, i: number) => (
                                              <div
                                                key={i}
                                                onClick={() => setProductIdx(i)}
                                                style={{
                                                  width: 5,
                                                  height: 5,
                                                  borderRadius: "50%",
                                                  cursor: "pointer",
                                                  background:
                                                    i === productIdx
                                                      ? "#66C15E"
                                                      : "#ccc",
                                                }}
                                              />
                                            ),
                                          )}
                                        </div>
                                        <small
                                          className="d-block text-center text-muted mt-1"
                                          style={{ fontSize: 10 }}
                                        >
                                          Click to view details
                                        </small>
                                      </>
                                    ) : (
                                      <span className="text-muted font-12">
                                        No Product Data Added
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                              </div>

                              {/* Buttons */}
                              <div className="d-flex gap-3">
                                <button
                                  className="btn flex-grow-1 text-white fw-semibold py-2"
                                  style={{
                                    background: "#7bb66a",
                                    borderRadius: 8,
                                    fontSize: 14,
                                  }}
                                  onClick={() => handleShowModal()}
                                  id={`btn_connect_${item?.business_info_uuid}`}
                                >
                                  Connect
                                </button>

                                <button
                                  className="btn btn-outline-success bg-white text-success flex-grow-1  fw-semibold py-2"
                                  style={{
                                    background: "#7bb66a",
                                    borderRadius: 8,
                                    fontSize: 14,
                                  }}
                                  onClick={() => handleShowModal()}
                                >
                                  View Profile
                                </button>
                              </div>
                            </div>
                          </Col>
                        );
                        })
                      )}
                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
        {showCarousel && (
          <ProductCarouselModal
            show={showCarousel}
            products={selectedProductList}
            startIndex={carouselStart}
            onClose={() => setShowCarousel(false)}
          />
        )}
        {showModal && (
          <ConfirmSubscriptionModal
            show={showModal}
            message={modalMessage}
            onConfirm={handleYes}
            onCancel={() => setShowModal(false)}
          />
        )}
        {showProfileJourney && (
          <ProfileJourneySection
            sectionKey="list_and_expand"
            show={showProfileJourney}
            onHide={() => {
              const today = new Date().toISOString().split("T")[0];
              localStorage.setItem("list_and_expand_journey_shown_date", today);
              setShowProfileJourney(false);
              fetchGlobalConnect();
            }}
          />
        )}
      </section>
    </>
  );
};

export default Listandexpand;
